// This file is generated do not modify manually
export const transactions = [
    { path: 'AccountSelector', loadChildren: () =>
    import('./transactions.module').then(m => m.TransactionsModule) },
    { path: 'Overview', loadChildren: () =>
    import('./transactions.module').then(m => m.TransactionsModule) },
    { path: 'SearchAndDownload', loadChildren: () =>
    import('./transactions.module').then(m => m.TransactionsModule) },
    { path: 'History', loadChildren: () =>
    import('./transactions.module').then(m => m.TransactionsModule) },
    { path: 'DownloadTransactions', loadChildren: () =>
    import('./transactions.module').then(m => m.TransactionsModule) },
    { path: 'Statements', loadChildren: () =>
    import('./transactions.module').then(m => m.TransactionsModule) },
    { path: 'StatementsList', loadChildren: () =>
    import('./transactions.module').then(m => m.TransactionsModule) },
    { path: 'PrintStatements', loadChildren: () =>
    import('./transactions.module').then(m => m.TransactionsModule) },
    { path: 'PrintTransactions', loadChildren: () =>
    import('./transactions.module').then(m => m.TransactionsModule) },
];
